/** @module Components */

import React, { JSX } from 'react'
import { Row, flexRender } from '@tanstack/react-table'
import tw from 'tailwind-styled-components'

/** @category Prop Types */
export type CustomRowProps = {
  /** Made up of Row objects from the react-table package */
  rows: Row<Record<string, unknown>>[]
  /** Optional parameter, allows additional TailwindCSS utility keywords to be passed in and applied to the entire Row */
  customRowClassName?: string
  /** Optional parameter, allows additional TailwindCSS utility keywords to be passed in and applied to each cell in the Row */
  customRowCellClassName?: string
}

const StyledRow = tw.tr`
  bg-white
  min-w-max
  border-b
  border-gray-200
  h-20
`

const StyledRowCell = tw.td`
  text-left
  whitespace-nowrap
  text-base
  text-gray-500
`

export const CustomTableRow: React.FC<CustomRowProps> = ({
  rows,
  customRowClassName,
  customRowCellClassName
}: CustomRowProps): JSX.Element => {
  return (
    <tbody>
      {rows.map((row) => {
        return (
          <StyledRow
            key={row.id}
            className={`${customRowClassName} hover:bg-gray-50 bg-white min-w-max border-b border-gray-200 h-20`}
          >
            {row.getVisibleCells().map((cell) => {
              return (
                <StyledRowCell
                  key={cell.id}
                  className={customRowCellClassName}
                  style={{ minWidth: '120px' }}
                >
                  <div className="flex justify-begin items-center">
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </div>
                </StyledRowCell>
              )
            })}
          </StyledRow>
        )
      })}
    </tbody>
  )
}
